import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { toast } from 'react-toastify';
import NotificacionesBell from '../Notificaciones/NotificacionesBell';

const Layout = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.info('Sesión cerrada');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 h-screen w-64 bg-gray-800 text-white flex flex-col">
        <div className="p-4 flex-shrink-0">
          <h1 className="text-xl font-bold">POS Platform</h1>
          <p className="text-sm text-gray-400">Administrador Central</p>
        </div>
        <nav className="flex-1 overflow-y-auto mt-8">
          <div className="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">
            Logística
          </div>
          <Link
            to="/paquetes/dashboard"
            className="block px-4 py-2 hover:bg-gray-700 transition"
          >
            Dashboard Paquetes
          </Link>
          <Link
            to="/paquetes/entrada"
            className="block px-4 py-2 hover:bg-gray-700 transition"
          >
            Entrada de Paquete
          </Link>
          <Link
            to="/paquetes/salida"
            className="block px-4 py-2 hover:bg-gray-700 transition"
          >
            Salida de Paquete
          </Link>
          <div className="px-4 py-2 mt-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
            Tienda
          </div>
          <Link
            to="/tienda"
            className="block px-4 py-2 hover:bg-gray-700 transition"
          >
            E-commerce
          </Link>
          <div className="px-4 py-2 mt-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
            CRM
          </div>
                <Link
                  to="/crm/trabajo"
                  className="block px-4 py-2 hover:bg-gray-700 transition"
                >
                  Mi Trabajo
                </Link>
                <Link
                  to="/crm"
                  className="block px-4 py-2 hover:bg-gray-700 transition"
                >
                  Dashboard CRM
                </Link>
          <Link
            to="/crm/leads"
            className="block px-4 py-2 hover:bg-gray-700 transition"
          >
            Leads
          </Link>
          <Link
            to="/crm/oportunidades"
            className="block px-4 py-2 hover:bg-gray-700 transition"
          >
            Pipeline
          </Link>
          <Link
            to="/crm/actividades/nueva"
            className="block px-4 py-2 hover:bg-gray-700 transition"
          >
            Nueva Actividad
          </Link>
        </nav>
      </aside>

      {/* Main Content */}
      <div className="ml-64">
        {/* Header */}
        <header className="bg-white shadow-sm">
          <div className="flex justify-between items-center px-6 py-4">
            <h2 className="text-xl font-semibold text-gray-800">Dashboard</h2>
            <div className="flex items-center gap-4">
              <NotificacionesBell />
              <span className="text-sm text-gray-600">
                {user?.name} ({user?.email})
              </span>
              <button
                onClick={handleLogout}
                className="px-4 py-2 text-sm text-white bg-red-600 rounded hover:bg-red-700 transition"
              >
                Cerrar Sesión
              </button>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;

